import { render, staticRenderFns } from "./resetPaawdform.vue?vue&type=template&id=7e2f2305&scoped=true&"
import script from "./resetPaawdform.vue?vue&type=script&lang=js&"
export * from "./resetPaawdform.vue?vue&type=script&lang=js&"
import style0 from "./resetPaawdform.vue?vue&type=style&index=0&id=7e2f2305&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.10.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.6.14_webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2f2305",
  null
  
)

export default component.exports